var map = {
	"./hotel1.png": 2372,
	"./hotel2.png": 75223,
	"./hotel3.png": 31622,
	"./hotel4.png": 53471,
	"./hotel5.png": 92976,
	"./hotel6.png": 60713,
	"./hotel7.png": 26948,
	"./hotel8.png": 14037
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37966;